<template>
  <validation-observer
    v-if="showAnotherInsurance"
    v-show="isRenderAfterFullfilled"
    v-slot="anotherInsuranceObserver"
    slim
  >
    <form-section
      id="another-insurance"
      :validated="formObserver.validated"
      v-bind="anotherInsuranceObserver"
    >
      <form-row label="In the last 2 years have you held car insurance in your own name?">
        <validation-provider
          v-slot="{ failed }"
          :data-unit-test="`${stepId}_another-insurance`"
          :vid="`${stepId}_another-insurance`"
          name="Another Insurance"
          :rules="{
            required: showAnotherInsurance,
          }"
        >
          <radio
            v-model="questionData.anotherInsurance"
            :name="`${stepId}-another-insurance`"
            :data-test="snakeCase(questionFields.anotherInsurance)"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-another-insurance',
  extends: QuestionBase,
  data () {
    return {
      fields: ['anotherInsurance'],
    };
  },
  computed: {
    showAnotherInsurance () {
      return this.stepData.noClaimsBonus === 0;
    },
  },
  created () {
    this.$watch('showAnotherInsurance', val => {
      this.questionData.anotherInsurance = val ? this.defaultValues.anotherInsurance : null;
    });
  },
};
</script>
